<template>
  <div class="quality-recommend">
    <div class="slider-banner swiper">
      <swiper class="swiper-wrapper" :options="RecommendSwiper">
        <swiperSlide class="swiper-slide" v-for="(item, index) in imgUrls" :key="index">
          <img :src="item.img" class="slide-image" />
        </swiperSlide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>
    <div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont icon-cuxiaoguanli"></span>今日特价
      </div>
      <div class="line"></div>
    </div>
    <Promotion-good :benefit="goodsList"></Promotion-good>
  </div>
</template>
<script>
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import "@assets/css/swiper.min.css";
  import PromotionGood from "@components/PromotionGood";
  import {
    getGroomList
  } from "@api/store";
  import {
    getSpecialofferList
  } from "@api/activity";
  export default {
    name: "GoodsPromotion",
    components: {
      swiper,
      swiperSlide,
      PromotionGood
    },
    props: {},
    data: function () {
      return {
        imgUrls: [],
        goodsList: [],
        RecommendSwiper: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 2000
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
          page: 1,
          limit: 20
        }
      };
    },
    mounted: function () {
      this.getIndexGroomList();
      this.getSpecialoffer();
    },
    methods: {
      getSpecialoffer() {
        var that = this;
        getSpecialofferList(1, 20)
          .then(res => {
            // console.log(res);
            that.goodsList = res.data;
          })
          .catch(function (res) {
            that.$dialog.toast({
              mes: res.msg
            });
          });
      },
      getIndexGroomList: function () {
        let that = this;
        getGroomList(4)
          .then(res => {
            that.imgUrls = res.data.banner;
            // that.goodsList = res.data.list;
          })
          .catch(function (res) {
            that.$dialog.toast({
              mes: res.msg
            });
          });
      }
    }
  };
</script>
